import { render, staticRenderFns } from "./subtitle.vue?vue&type=template&id=3aef690e&"
import script from "./subtitle.vue?vue&type=script&lang=js&"
export * from "./subtitle.vue?vue&type=script&lang=js&"
import style0 from "./subtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports